import { useMemo } from 'react'

import type { ManifestTableRow } from '@b-stock/fe-core/bstock-next/components'
import { buildManifestTableRows } from '@b-stock/fe-core/bstock-next/components'
import type { OrchestratedListingDetails } from '@b-stock/fe-core/bstock-next/queries'

export function useManifestPreviewRows(
  listing: OrchestratedListingDetails
): ManifestTableRow[] {
  return useMemo(() => {
    if (!listing.inventoryPreview) return []
    const { groups } = listing.lot
    return buildManifestTableRows(
      listing.inventoryPreview.map((item) => ({
        ...item,
        group: groups.find((g) => g._id === item.groupId) ?? null,
      }))
    )
  }, [listing.inventoryPreview, listing.lot])
}
